var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookAd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3013_74732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1929 31.0412V18.2324H24.5513L25.2038 13.2406H20.1929V10.0535C20.1929 8.60824 20.5998 7.62325 22.7008 7.62325L25.3804 7.62203V3.15742C24.9168 3.09681 23.3263 2.96094 21.4758 2.96094C17.6124 2.96094 14.9675 5.28714 14.9675 9.55933V13.2407H10.5978V18.2325H14.9673V31.0414L20.1929 31.0412Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3013_74732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.7826,
    height: 28.087,
    transform: "translate(10.5978 2.95703)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookAd);
export default __webpack_public_path__ + "static/media/FacebookAd.8d25ff7706d22801cc51530cab655e30.svg";
export { ForwardRef as ReactComponent };